import { useState } from "react";

import { useQuery, useMutation } from "@tanstack/react-query";
import {
  Flex,
  Label,
  Button,
  Checkbox,
  FormGroup,
  TextInput,
  InnerPanel,
} from "@sopranodesign/pulse-components";

import { createRole } from "../../api";

const defaultRole = {
  name: "",
  permissions: [],
};

const RoleDetails = ({ handleClose }) => {
  const [role, setRole] = useState(defaultRole);

  const query = useQuery({ queryKey: ["permissions"] });

  const mutation = useMutation({
    mutationFn: createRole,
    onSuccess: () => handleClose(),
  });

  const handleSelectPermission = (permission) => {
    if (role.permissions.includes(permission.id)) {
      return setRole({
        ...role,
        permissions: role.permissions.filter((id) => id !== permission.id),
      });
    }

    setRole({ ...role, permissions: role.permissions.concat(permission.id) });
  };

  const handleNameChange = (e) => setRole({ ...role, name: e.target.value });

  const handleSubmit = () => {
    mutation.mutate({
      name: role.name,
      permissions: role.permissions,
    });
  };

  const valid = Boolean(role.name && role.permissions.length > 0);

  return (
    <InnerPanel>
      <FormGroup>
        <Label htmlFor="role-name">Role Name</Label>
        <TextInput
          id="role-name"
          placeholder="King of the World"
          onChange={handleNameChange}
          value={role.name}
        />
      </FormGroup>
      <FormGroup>
        <Label>Permissions</Label>
        {query.isSuccess &&
          query.data.data.map((permission) => (
            <Flex mt key={permission.id}>
              <Checkbox
                checked={role.permissions.includes(permission.id)}
                label={permission.name}
                onChange={() => handleSelectPermission(permission)}
              />
            </Flex>
          ))}
      </FormGroup>
      <Flex right>
        <Button
          disabled={!valid}
          onClick={() => handleSubmit()}
          variant="primary"
        >
          Create
        </Button>
      </Flex>
    </InnerPanel>
  );
};

export default RoleDetails;
